import {
  buildImageCdnUrl,
  getImageOptimisationEnabled,
  isImgixUrl,
} from '../constants/imageCdn';

type ImageLoaderParams = { src: string; width?: number; quality?: number };
type OptimizeImageParams = { src: string; width?: number; quality?: number };

const DEFAULT_PLACEHOLDER_URL =
  'https://s3.eu-west-2.amazonaws.com/assets.feast-it.com/default_supplier.png';

export function optimizeImageUrl({
  src,
  width,
  quality,
}: OptimizeImageParams): string {
  if (!src || src === 'undefined' || src.trim() === '') {
    return DEFAULT_PLACEHOLDER_URL;
  }

  if (!isImgixUrl(src)) {
    return src;
  }

  return buildImageCdnUrl(src, {
    enabled: getImageOptimisationEnabled(),
    auto: 'format,compress',
    fit: 'max',
    width,
    quality: quality ?? 50,
  });
}

export default function imageLoader({
  src,
  width,
  quality,
}: ImageLoaderParams): string {
  if (!src || src === 'undefined' || src.trim() === '') {
    return DEFAULT_PLACEHOLDER_URL;
  }

  return buildImageCdnUrl(src, {
    enabled: getImageOptimisationEnabled(),
    auto: 'format,compress',
    fit: 'max',
    width,
    quality: quality ?? 50,
  });
}
